import { LazyAction, LazyModule } from 'owa-bundling';

import ActionType from './store/schema/ActionType';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Lightning" */ './lazyIndex'));

export { store } from './store/store';
export { ActionType };

export let beginLightning = new LazyAction(lazyModule, m => m.beginLightningImp);
export let endLightning = new LazyAction(lazyModule, m => m.endLightningImp);
